<template>
  <div id="footer">
    <!-- ========================== -->
    <!-- FOOTER - FOOTER -->
    <!-- ========================== -->
    <section class="footer-section">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-3">
            <div class="widget">
              <h5 class="widgetheading">联系我们</h5>
              <address style="color: #cccccc; font-weight: bold;line-height: 30px;">
                联盛纸业
              </address>
              <address style="color: #cccccc">
                联盛纸业（龙海）有限公司<br />
                福建省漳州台商投资区角美镇凤山工业园角江路
              </address>
              <p >
                <i class="glyphicon glyphicon-earphone"></i
                >&nbsp;0596-6782929
              </p>

              <address style="color: #cccccc; font-weight: bold;line-height: 30px;">
                联盛浆纸
              </address>
              <address style="color: #cccccc">
                联盛浆纸（漳州）有限公司<br />
                福建省漳州市漳浦县赤湖镇亭里村下亭288号
              </address>
              <p>
                <i class="glyphicon glyphicon-earphone"></i
                >&nbsp;0596-3999318
              </p>
              <!-- <p></p>
              <p>
                <i class="glyphicon glyphicon-user"></i>&nbsp;蔡小姐、林先生
              </p>
              <p>
                <i class="glyphicon glyphicon-earphone"></i
                >&nbsp;0596-6782929&nbsp;/&nbsp;3999318
              </p>
              <p>
                <i class="glyphicon glyphicon-envelope"></i>&nbsp;hr@fjlszy.com
              </p>
              <p>QQ&nbsp;1964975982</p> -->
            </div>
          </div>
          <div class="col-md-3" style="padding-right: 30px">
            <div class="widget">
              <h5 class="widgetheading">出发联盛</h5>
              <!-- <h5 class="widgetheading">
                <a
                  href="https://map.baidu.com/?newmap=1&amp;shareurl=1&amp;l=16.912540933621592&amp;tn=B_NORMAL_MAP&amp;hb=B_SATELLITE_STREET&amp;c=13121790,2796336&amp;s=s%26da_src%3DsearchBox.button%26wd%3D%E8%81%94%E7%9B%9B%E7%BA%B8%E4%B8%9A(%E9%BE%99%E6%B5%B7)%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%26c%3D255%26src%3D0%26wd2%3D%26pn%3D0%26sug%3D0%26l%3D15%26b%3D(13116421%2C2793884%3B13127349%2C2798764)%26from%3Dwebmap%26biz_forward%3D%7B%22scaler%22%3A1%2C%22styles%22%3A%22pl%22%7D%26sug_forward%3D%26auth%3DBz6F6xfO%40VFdAwH1OWYIdy2HU%3D185TDUuxHEHzTzLLLtexZFTHrwzvwi04vy77u1GgvPUDZYOYIZuVt1cv3uVtGccZcuVtPWv3Guzt7xjhN%40ThwzBDGJ4P6VWvcEWe1GD8zv7u%40ZPuVteuVtegvcguxHEHzTzzLLtjnOOADzs99Xv7%26device_ratio%3D1"
                  target="_blank"
                  title="点击查看地图"
                  >出发联盛</a
                >
              </h5> -->
              <ul class="link-list" style="color: #cccccc;">
                <a
                  href="https://map.baidu.com/?newmap=1&amp;shareurl=1&amp;l=16.912540933621592&amp;tn=B_NORMAL_MAP&amp;hb=B_SATELLITE_STREET&amp;c=13121790,2796336&amp;s=s%26da_src%3DsearchBox.button%26wd%3D%E8%81%94%E7%9B%9B%E7%BA%B8%E4%B8%9A(%E9%BE%99%E6%B5%B7)%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%26c%3D255%26src%3D0%26wd2%3D%26pn%3D0%26sug%3D0%26l%3D15%26b%3D(13116421%2C2793884%3B13127349%2C2798764)%26from%3Dwebmap%26biz_forward%3D%7B%22scaler%22%3A1%2C%22styles%22%3A%22pl%22%7D%26sug_forward%3D%26auth%3DBz6F6xfO%40VFdAwH1OWYIdy2HU%3D185TDUuxHEHzTzLLLtexZFTHrwzvwi04vy77u1GgvPUDZYOYIZuVt1cv3uVtGccZcuVtPWv3Guzt7xjhN%40ThwzBDGJ4P6VWvcEWe1GD8zv7u%40ZPuVteuVtegvcguxHEHzTzzLLtjnOOADzs99Xv7%26device_ratio%3D1"
                  target="_blank"
                  title="点击查看地图"
                  style="font-weight: bold;display: inline-block;margin-bottom: 8px;"
                >联盛纸业</a>
                <li>
                  <i class="glyphicon glyphicon-circle-arrow-right"></i
                  >&nbsp;自驾车导航至联盛纸业（龙海）有限公司
                </li>
                <li>
                  <i class="glyphicon glyphicon-circle-arrow-right"></i
                  >&nbsp;乘动车到角美动车站再乘车至联盛纸业1号门
                </li>
                <li>
                  <i class="glyphicon glyphicon-circle-arrow-right"></i
                  >&nbsp;从厦门搭乘709、830、832等公交车至角美文圃大道，再乘车至联盛纸业1号门
                </li>
              </ul>
              <ul class="link-list" style="color: #cccccc;">
                <a
                  href="https://map.baidu.com/search/%E8%81%94%E7%9B%9B%E6%B5%86%E7%BA%B8(%E6%BC%B3%E5%B7%9E)%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8-1%E5%8F%B7%E9%97%A8/@13123964.335,2746092.91,19z?querytype=s&da_src=shareurl&wd=%E8%81%94%E7%9B%9B%E6%B5%86%E7%BA%B8(%E6%BC%B3%E5%B7%9E)%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8-1%E5%8F%B7%E9%97%A8&c=255&src=0&wd2=%E6%BC%B3%E5%B7%9E%E5%B8%82%E6%BC%B3%E6%B5%A6%E5%8E%BF&pn=0&sug=1&l=13&b=(13099732.835,2734784.07;13154356.835,2763520.07)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=d31e26eb8408ef5f3804b103&device_ratio=2"
                  target="_blank"
                  title="点击查看地图"
                  style="font-weight: bold;line-height: 30px;display: inline-block;margin-top: 10px;"
                  >联盛浆纸</a
                >
                <li>
                  <i class="glyphicon glyphicon-circle-arrow-right"></i
                  >&nbsp;自驾车导航至联盛浆纸（漳州）有限公司1号门
                </li>
                <li>
                  <i class="glyphicon glyphicon-circle-arrow-right"></i
                  >&nbsp;乘动车到漳州站、漳浦站，再乘车至联盛浆纸1号门
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3" >
            <div class="widget">
              <h5 class="widgetheading">营业执照</h5>
              <a href="../assets/img/yyzz.jpg" title="点击我看大图" target="_blank">
                <img style="margin: 2px" height="200" src="../assets/img/yyzz.jpg" />
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="widget">
              <h5 class="widgetheading">关注我们</h5>
              <img src="../assets/img/wx-qrcode.jpg" class="img" width="200" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="copyright-section">
      <p>
        Copyright © 2018-2020. All rights reserved
        <a href="http://www.fjlszy.com" title="联盛纸业（龙海）有限公司"
          >联盛纸业（龙海）有限公司</a
        >
        -
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >闽ICP备12020615号</a>
      </p>
      <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35060102000031"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "
        >
          <p style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px">
            <img src="../assets/img/wjba.png" />&nbsp;&nbsp;闽公网安备 35060102000031号
          </p>
        </a>
    </section>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* footer-section */
.footer-section { padding: 80px 0 70px; background: #1a1a1a; }
.footer-section h5 { color: #cccccc; }
.footer-section p { color: #999999; font-size: 12px; }
.footer-section .footer-nav li { line-height: 24px; }
.footer-section .footer-nav li.active a { color: #0ebeff; }
.footer-section .footer-nav li a { font-size: 12px; line-height: 2; font-family: 'Raleway', sans-serif; color: #999999; text-decoration: none; }
.footer-section .footer-nav li a:hover { color: #0ebeff; }
.footer-section .contacts-list i { min-width: 20px; margin-right: 10px; }
.footer-section .contacts-list p { margin-bottom: 0; }
.footer-section .contacts-list a { color: #999; text-decoration: none; }
.footer-section .form-control { border-color: #333333; }
.footer-section .form-control:focus, .footer-section .form-control:active { border-color: #999; }
.footer-section .form-control-feedback { color: #999; }

/* copyright-section */
.copyright-section { padding: 30px 0; text-align: center; background: #000000; }
.copyright-section p { margin-bottom: 0; font-size: 10px; text-transform: uppercase; color: #999; font-family: 'Montserrat', sans-serif; }
.copyright-section p span { color: #ccc; }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue